import React, { useEffect, useState } from "react";
import { Link, useLocation, useSearchParams } from "react-router-dom";
import { appConfig } from "../../appConfig";
import { footerData } from "./footerData";
import ReactWhatsappButton from "react-whatsapp-button";
import PAY from "../../assets/images/banner/pay.png";
import TPP from "../../assets/images/banner/tpp.png";
import IATA from "../../assets/images/banner/iata.png";


const Footer = props => {

  const headRoute = appConfig.headRoute
  const [pkgtype, setpkgtype] = useState()
  const location = useLocation();
  const [searchParams, setSearchParams] = useSearchParams()

  useEffect(() => {

    const catId = searchParams.get("category");
    const pt = searchParams.get("type");
    setpkgtype(pt);

  }, [location.pathname, searchParams]);

    const getNo = () => {
    const whatsappStyle = { bottom: '3.5rem' }; /* a little bit up from default 2rem */
    if (pkgtype == 'umrah')
      return <ReactWhatsappButton
        countryCode="44"
        phoneNumber="2081949506"
        style={whatsappStyle}
      />
    else if (pkgtype == 'holiday')
      return <ReactWhatsappButton
        countryCode="44"
        phoneNumber="2081949506"
        style={whatsappStyle}
      />
    else
      return <ReactWhatsappButton
        countryCode="44"
        phoneNumber="2081949506"
        style={whatsappStyle}
      />
  }

  return (

    <div className="bg-navy-900 flex py-8 md:py-10">
      <div className="w-full">
        <div className="mb-4 md:mb-6 mt-0">
          <div className="flex flex-col md:flex-row justify-center items-center mb-3 md:px-12">
            <a href="https://uk.trustpilot.com/review/skyrisetravels.co.uk" target="_blank" rel="noopener noreferrer" className="flex items-center">
              <img src={TPP} alt="Trustpilot" className="h-[80px] mb-0" />
            </a>
          </div>



          {/* Copyright and Other Information */}

          <hr className="my-4 mx-[5px] border-t-2 border-white w-[100%]" />

          {/* Quick Links Section */}
          <div className="flex flex-wrap justify-center gap-8 mb-5">
            <a href="/" className="text-white text-lg hover:text-gray-300 transition-colors duration-300">Home</a>
            <a href="/traveltips" className="text-white text-lg hover:text-gray-300 transition-colors duration-300">TravelTips</a>
            <a href="/tc" className="text-white text-lg hover:text-gray-300 transition-colors duration-300">Terms & Conditions</a>
            <a href="/privacypolicy" className="text-white text-lg hover:text-gray-300 transition-colors duration-300">Privacy Policy</a>
            <a href="/aboutus" className="text-white text-lg hover:text-gray-300 transition-colors duration-300">FAQ</a>
          </div>

          {/* Address and Logo Section */}
          <div className="flex items-center justify-between text-white mb-5">
            {/* Address Section */}


            <div className="text-center flex-1">
              <p className="text-lg font-bold mb-2">Our Address</p>
              <p className="text-md font-semibold">SkyRise Travels LTD</p>
              <p className="text-md">4 - 6 Greatorex Street</p>
              <p className="text-md">London, E1 5NF, United Kingdom</p>
              <p className="text-md">Company No: 17183514</p>
              <p className="text-md">info@skyrisetravels.co.uk</p>
            </div>



          </div>



          {/* <ReactWhatsappButton
                countryCode="44"
                phoneNumber="7365892753"
            /> */}

          {
            getNo()
          }

          <hr className="my-4 mx-[5px] border-t-2 border-white w-[100%]" />


          {/* Payment Logos */}
          <div className="flex flex-col items-center mt-5">
            {/* Payment Logos */}
            <div className="flex items-center mb-3">
              <img src={PAY} alt="Payment Logos" className="h-12" />
            </div>

            {/* Copyright Text */}
            <p className="text-white text-sm lg:text-md text-center">
              Copyright © 2026 SkyRise Travels. All rights reserved.
            </p>
          </div>
        </div>
      </div>
    </div>

  )
}
export default Footer